module.exports = __webpack_public_path__ + "static/media/x.b3f126ed.svg";